import { useEffect } from "react";

const AllocatePoints = ({ allocatedPoints, required, setAllocatedPoints, points, max, disable }) => {

    // const [points, setPoints] = useState(0);
    
    const handlePointChange = (e) => {
        // setPoints(e.target.value);
        setAllocatedPoints(e.target.value);
    }
    
    // useEffect(() => {
    //     setAllocatedPoints(allocatedPoints);
    // }, [allocatedPoints]);
    
    return (
        <div className="flex justify-between items-center">
            <p className="inline font-semibold min-w-28">Allocate Points:</p>
            <input
                type="number"
                className="border border-navBtn rounded-md p-1 ml-2 disabled:cursor-not-allowed"
                placeholder="Allocate Points"
                value={allocatedPoints}
                onChange={e => handlePointChange(e)}
                required={required}
                max={max}
                disabled={disable}
            />
        </div>
    );
}

export default AllocatePoints;